/**
 * dayjs z pluginami i lokalizacjami (zastępuje moment.js).
 * Użyj tego modułu zamiast importować dayjs bezpośrednio.
 */
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import 'dayjs/locale/hr';
import 'dayjs/locale/sr';
import 'dayjs/locale/sl';
import 'dayjs/locale/en';

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);

export default dayjs;
